import { debounceEvent } from './_debounce';

( function( $, document, window, debounceEvent ) {
	'use strict';

	
	// Slick Slideshow
	var $columnsIcons = $( document.querySelectorAll( '.column-section.-format_icons:not(.-bordered) .wrapper' ) );

	if ( $columnsIcons.length <= 0 ) {
		return;
	}

	$( document ).ready( function() {

		var slickifyIcons = function() {
			$columnsIcons.slick( {
				autoplay: false,
				speed: 500,
				arrows: false,
				dots: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				mobileFirst: true,
				prevArrow: '',
				nextArrow: '',
				responsive: [
					{
						breakpoint: 767,
						settings: 'unslick'
					}
				]
			} );
		};

		// Run Slick
		slickifyIcons();

		// Reslick after unslicking
		var reslick = debounceEvent( function() {
			var $windowWidth = $( window ).width();

			if ( 768 > $windowWidth && true === $columnsIcons.slick( 'getSlick' ).unslicked ) {
				slickifyIcons();
			}
		}, 100 );

		window.addEventListener( 'resize', reslick );

	} );

} )( jQuery, document, window, debounceEvent );
